import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import PlaylistsIndex from 'components/PlaylistsIndex'
import { PlaylistsStore } from 'stores/playlists'
import { getVideosFeedNavOptions } from 'utils'
import { usePagination, useStore, useFeedPageView } from 'hooks'
import { getStaticWrapper } from 'utils'

const PlaylistsIndexPage = ({ items }) => {
  const playlistsStore = useStore(PlaylistsStore, { items })
  const pagination = usePagination(playlistsStore.items, (query) => playlistsStore.findNext(query))
  useFeedPageView(pagination)

  const adSettings = {
    slot: 'section',
    revContentSlot: 'Feed',
    keyValues: {}
  }
  return (
    <SiteLayout feedNavOptions={getVideosFeedNavOptions('/videos/playlists')} adSettings={adSettings}>
      <Head
        title='Video Playlists | Barstool Sports'
        description='Use Barstool Sports original video playlists to catch up on The Rundown, One Bite Pizza Reviews and your favorite shows.'
      />
      <PlaylistsIndex {...pagination} adSettings={adSettings} />
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper(async () => {
  const items = await PlaylistsStore().find()
  return { items }
})

export default PlaylistsIndexPage
